/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} PreviousInputs */



/**
* | output |
* | --- |
* | "Previous" |
*
* @param {PreviousInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const previous = /** @type {((inputs?: PreviousInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<PreviousInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Précédent")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorherige")
	if (locale === "it") return /** @type {LocalizedString} */ ("Precedente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предыдущий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Anterior")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("以前的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("前の")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पहले का")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Anterior")
	return /** @type {LocalizedString} */ ("Previous")
});